import { Component, OnInit } from "@angular/core";

import * as $ from "jquery";
import { map, tap } from "rxjs/operators";
import { SaveService } from "../services/save.service";
import { ApiService } from "../services/api.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription, from } from "rxjs";
import { RouterModule, Routes, NavigationEnd, NavigationStart, RoutesRecognized, ActivationStart, ActivationEnd } from "@angular/router";
import { MedicinService } from "../services/index";
import { PrerequisiteService } from "../services/prerequisite.service";


@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
  providers: [ApiService]
})
export class FooterComponent implements OnInit {
  brandName;
  logo;
  isSuccess = false;
  newserror: any = "";
  news_sucess: any = false;
  sendno: any = "";
  sendmessageClass: any = "";
  sendmessageStatus: any = "";
  currentYear: number = new Date().getFullYear();
  subscription: Subscription;
  littleAngleFooter = false;
  petPrescriptionsFooter = false;
  showloginbox = false;
  signup_fields = false;
  signin_fields = false; 
  otp_sent: any = false;
  forgotpassword_box: any = false;
  googlegenericpassval:any="";
  applegenericpassval:any="";
  android:any=true;
  ios:any=true;
  desktop:any=true;
  showemailpopup:any=false;
  UserInputEmailcard:string="";
  UserInputEmailcarderror:any="";

  private sign_in_error = "";
  private sign_up_error = "";
  private sign_in_email: string = "";
  private sign_in_password: string = "";
  private sign_in_email_error: string = "";
  private sign_in_password_error: string = "";
  public sign_in_user_email: string = "";
  public input_groupnumber_error: string = "";
  private input_otp: string = "";
  private reset_update_password_error: string = "";

  private sign_up_email: string = "";
  private sign_up_password: string = "";
  private sign_up_cpassword: string = "";
  private sign_up_email_error: string = "";
  private sign_up_password_error: string = "";
  private sign_up_cpassword_error: string = "";
  private input_otp_error: string = "";

  private current_password: string = "";
  private new_password: string = "";
  private c_new_password: string = "";
  private current_password_error: string = "";
  private new_password_error: string = "";
  private c_new_password_error: string = "";
  public Group_Number_Box: boolean = false;

  private forgot_email: string = "";
  private forgot_email_error: string = "";

  private forgot_new_password: string = "";
  private forgot_new_password_error: string = "";
  Sendtext:any="Send";


  newsletter() {
    var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var newsLetterMail = $("input[name='email_']").val();
    // if (newsLetterMail != "" && newsLetterMail.match(mailformat)) {
    if (newsLetterMail != "") {
      this.ApiService
        .addActiveContact(newsLetterMail, "", "", "newsletter")
        .pipe(map(res => res.json()))

        .subscribe(data => {
          $("input[name='email_']").val("");
          $('.fnewss').show();
        });
    } else if (!newsLetterMail.match(mailformat) && newsLetterMail != "") {
      $("#newsvalidator")
        .css({ display: "block", color: "#f19f57" })
        .prev()
        .css("border-color", "#f19f57");
      this.newserror = "Please enter a valid email address";
    } else {
      $("#newsvalidator")
        .css({ display: "block", color: "#f19f57" })
        .prev()
        .css("border-color", "#f19f57");
      this.newserror = "Please enter a valid email address";
    }
  }
  removeerror(event) {
    $("#newsvalidator")
      .hide()
      .prev()
      .removeAttr("style");
    $('.fnewss').hide();
  }

  constructor(
    private saveService: SaveService,
    private ApiService: ApiService,
    public router: Router,
    private ms: MedicinService,
    private rs: PrerequisiteService,
  ) { 
    this.router.events.subscribe(event => {
      ;
    let url = this.router.url;
    if (url == "/little-angel-hands") {
      this.littleAngleFooter = true;
      console.log('footer: ' + this.littleAngleFooter);
    } else this.littleAngleFooter = false;
  })
  this.router.events.subscribe(event => {
    ;
  let url = this.router.url;
  if (url == "/petPrescriptions") {
    this.petPrescriptionsFooter = true;
    console.log('footer: ' + this.petPrescriptionsFooter);
  } else this.petPrescriptionsFooter = false;
})
  }


  ngOnInit() {
    let userAgent = window.navigator.userAgent;
    let devicetype = this.GetUserAgent(userAgent);
    let browsername = this.GetBrowserName(userAgent);
    this.googlegeneric('023518', 'ARX', '100-4542')
    this.applegeneric('023518', 'ARX', '100-4542')
//  alert(devicetype + '--' + browsername);
   //  --Chrome
    if(devicetype == "Desktop") {
     this.android=true;
     this.ios=true;
    }
    if(devicetype =="iPhone") {
     this.android=false;
     this.ios=true;
    }
    if(devicetype =="Android") {
     this.android=true;
     this.ios=false;
    }
    $(".footer-nav a").click(function () {
      $(".navbar-nav a").removeClass("home-active");
    });
    this.brandName = this.saveService.getFooterBrandName();
    this.logo = this.saveService.getLogo();
  }
  GetBrowserName(UserAgent_Raw) {
    if (/Firefox/i.test(UserAgent_Raw)) {
        return 'Firefox';
    } else if (/Chrome/i.test(UserAgent_Raw)) {
        return 'Chrome';
    } else if (/Safari/i.test(UserAgent_Raw)) {
        return 'Safari';
    } else if (/MSIE|Trident/i.test(UserAgent_Raw)) {
        return 'Internet Explorer';
    } else if (/Edge/i.test(UserAgent_Raw)) {
        return 'Edge';
    } else if (/Opera|OPR/i.test(UserAgent_Raw)) {
        return 'Opera';
    } else if (/Brave/i.test(UserAgent_Raw)) {
        return 'Brave';
    } else if (/Vivaldi/i.test(UserAgent_Raw)) {
        return 'Vivaldi';
    } else if (/Yandex/i.test(UserAgent_Raw)) {
        return 'Yandex';
    } else if (/Chromium/i.test(UserAgent_Raw)) {
        return 'Chromium';
    } else {
        return 'Unknown';
    }
}
  GetUserAgent(UserAgent_Raw) {
    if (/Mobi|Android/i.test(UserAgent_Raw)) {
        if (/iPhone|iPad|iPod/i.test(UserAgent_Raw)) {
            return 'iPhone';
        }
        else {
            return 'Android';
        }
    } else {
        return 'Desktop';
    }
}
  removesignup(event) {
    this.ms.Setsignup(false, false, false);
    this.showloginbox = this.ms.Getsignup()[0];
    this.signup_fields = this.ms.Getsignup()[1];
    this.signin_fields = this.ms.Getsignup()[2];
    $("body").removeAttr("style");
  }
  ForgotPassword() {
    this.otp_sent = false;
    this.forgot_email_error = null;
    this.input_otp_error = null;
    this.input_otp = null;
    this.reset_update_password_error = null;
    this.forgotpassword_box = true;
  }
  removeStyle(val) {
    // ie fix issue
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    var edge = ua.indexOf('Edge/');
    var ff = ua.indexOf('Firefox');
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || edge > 0 || ff > 0)  // If Internet Explorer, return version number
    {
      if (val == "home_screen" || val == 'sign_up' || val == 'sign_in') {
        $(".ie_fixed_add_n, #Signin_Signup_Header").removeAttr("style");
      }
    }
  }
  SharePassonemail() {
    
    let email = this.UserInputEmailcard;
    if (!email) {
      this.UserInputEmailcarderror = "Please fill this fields.";
      return;
    }

    // Simple email validation
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.UserInputEmailcarderror = "Please enter a valid email address.";
      return;
    }
    debugger;
this.Sendtext="Sending"
    this.ApiService.SendChromeemail(this.applegenericpassval, email)
    .pipe(map(res => res.json()))
    .subscribe(
      data => {
        debugger;
        if(data[0].message=="Mail sent successfully") {
          this.Sendtext="Sent"
          setTimeout(() => {
            this.Sendtext="Send"
          }, 1500);
        }
        else {
          this.UserInputEmailcarderror=data[0].message;
          setTimeout(() => {
            this.Sendtext="Send"
          }, 1500);
        }
      }
    )
    
    
  }
  clearMessage() {
    this.UserInputEmailcarderror=""
  }
  ClearErrorMessage() {
    this.sign_in_email_error = "";
    this.sign_in_password_error = "";
    this.sign_up_email_error = "";
    this.sign_up_password_error = "";
    this.sign_up_cpassword_error = "";
    this.sign_in_email = "";
    this.sign_in_password = "";
    this.sign_up_email = "";
    this.sign_up_password = "";
    this.sign_up_cpassword = "";
    this.input_groupnumber_error = "";
    this.current_password_error = "";
    this.new_password_error = "";
    this.c_new_password_error = "";
    this.sign_in_error = null;
    this.sign_up_error = "";
  }
  openlogin_signup(event, val) {
    this.removeStyle(val);
    this.ClearErrorMessage();
    this.ms.Getsignup();
    if (val == "sign_up") {
      this.ms.Setsignup(true, true, false);
      this.showloginbox = this.ms.Getsignup()[0];
      this.signup_fields = this.ms.Getsignup()[1];
      this.signin_fields = this.ms.Getsignup()[2];
      $("body").css("overflow", "hidden");
    }
    else if (val == "my_cards") {
      if (this.rs.GetUserLoggedInStatus() == "signupscreen") {
        this.ms.Setsignup(true, true, false);
        this.showloginbox = this.ms.Getsignup()[0];
        this.signup_fields = this.ms.Getsignup()[1];
        this.signin_fields = this.ms.Getsignup()[2];
        $("body").css("overflow", "hidden");
        return false;
      }
      if (window.localStorage.getItem('UserGroup') == null || window.localStorage.getItem('UserGroup') == "False" || window.localStorage.getItem('UserGroup') == "null" || window.localStorage.getItem('UserGroup') == "") {
        this.Group_Number_Box = true;
        // $(".TestGroup a")[0].click();
        return false;
      }
      else {
        this.router.navigate(["/MyCards"]);
      }
    }
    else if (val == "groupnumber") {
      this.Group_Number_Box = true;
      $("body").css("overflow", "hidden");
    } else {
      this.ms.Setsignup(true, false, true);
      this.showloginbox = this.ms.Getsignup()[0];
      this.signup_fields = this.ms.Getsignup()[1];
      this.signin_fields = this.ms.Getsignup()[2];
      $("body").css("overflow", "hidden");
    }
    // ie fix issue
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    var edge = ua.indexOf('Edge/');
    var ff = ua.indexOf('Firefox');
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || edge > 0 || ff > 0)  // If Internet Explorer, return version number
    {
      if (val == "my_cards" || val == "home_screen") {
        $(".ie_fixed_add_n, #Signin_Signup_Header").removeAttr("style");
      }
    }
  }  
  removemsgerr(e) {
    this.sendmessageStatus = "";
    this.sendmessageClass = "";
    var val_old = e.target.value;
    var val = val_old.replace(/\D/g, "");
    var len = val.length;
    if (len >= 1) {
      val = "(" + val.substring(0);
    }
    if (len >= 3) {
      val = val.substring(0, 4) + ")" + "-" + val.substring(4);
    }
    if (len >= 6) {
      val = val.substring(0, 9) + "-" + val.substring(9);
    }
    if (val != val_old) {
      $(event.target)
        .focus()
        .val("")
        .val(val);
    }
  }
  googlegeneric(bin, pcn, memberid){
    this.ApiService.googlegeneric(bin, pcn, window.localStorage.getItem("UserGroup"), memberid)
    .pipe(map(res => res.json()))
    .subscribe(
      data => {
if(data[0].passlink != "") {
  this.googlegenericpassval = data[0].passlink
}
      })
  }
  applegeneric(bin, pcn, memberid){
    this.ApiService.applegeneric(bin, pcn, window.localStorage.getItem("UserGroup"), memberid)
    .pipe(map(res => res.json()))
    .subscribe(
      data => {
if(data[0].passlink != "") {
  this.applegenericpassval = data[0].passlink
}
      })
  }
  openpass(url) {
    debugger
    let userAgent = window.navigator.userAgent;
    let devicetype = this.GetUserAgent(userAgent);
    let browsername = this.GetBrowserName(userAgent);

    if(devicetype == "Desktop") {
      window.open(url)
     }
     
     if(devicetype =="Android") {
      window.open(url)
     }
     if(devicetype =="iPhone" && browsername == "Safari") {
      window.open(url)      
      //this.showemailpopup=true;
     }
     if(devicetype =="iPhone" && browsername != "Safari")  {
      this.showemailpopup=true;
     }
    
  }
  sendmsg(val) {
    console.log(val);
    let mobUsPattern = "^(([0-9]{3}) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$";

    ;
    if (val != "" && val.length >= 7) {
      let deeplink = window.localStorage.getItem("DeepLinkURL");
      this.ApiService.sendSms(val, deeplink)
        .pipe(
          tap(
            data => {
              ;
            },
            error => {
              ;
              let errorData = (this.sendmessageStatus = JSON.parse(
                error._body
              ));
              if (errorData.code == "21408") {
                this.sendmessageStatus = "Please enter a valid country code";
                this.sendmessageClass = "msgerror";
              } else if (errorData.code == "21211") {
                this.sendmessageStatus = "Please enter a valid phone number";
                this.sendmessageClass = "msgerror";
              } else {
                this.sendmessageStatus = "Please enter a valid phone number";
                this.sendmessageClass = "msgerror";
              }
            }
          )
        )
        .subscribe(data => {
          this.sendmessageClass = "Success_sent";
          this.sendmessageStatus = "Message Sent";
          setTimeout(() => {
            this.sendmessageClass = "";
            this.sendmessageStatus = "";
            this.sendno = "";
          }, 6000);
        });
    } else {
      this.sendmessageStatus = "Please enter a valid phone number";
      this.sendmessageClass = "msgerror";
    }

    /*
    var phoneNumber = val // +919812345678, +442071234567
    var linkData = {
      campaign: 'Microsite form Data'
    };
    var linkOptions = {
      make_new_link: false // don't create a new deep link if one already exists (e.g. _branch_match_id is in the address bar)
    };
    (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})
    (window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);              
      // init Branch
      this.branch.init('key_test_kbVA7KLYjQr3IhziIq9prflaBwjkef5p');
      // document.getElementById("myBtn").addEventListener("click", function(){
      this.branch.sendSMS(val, linkData, linkOptions, function(err, data) {
      console.log(err);
    });
    */
  }
  slideToggle() {
    if (screen.width <= 767) {
      // $('.navbar-nav').slideToggle('slow');
      // $('.navbar').toggleClass('less');    
      if ($('.navbar').hasClass('less')) {
        $('#slide-icon').attr('src', 'assets/images/close.png').delay("slow").fadeIn();
      } else {
        $('#slide-icon').attr('src', 'assets/images/menu.svg').delay("slow").fadeIn();
      }
    }
  }
  signuppop() { 
    debugger
    $('a.last.signUp')[0].click()
   };
  
}
